import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "./components/Sidebar/Sidebar";
import MyAds from "./components/MyAds/MyAds";
import CreateAd from "./components/CreateAd/CreateAd";
import Settings from "./components/Settings/Settings";
import Support from "./components/Support/Support";
import EditAd from "./components/EditAd/EditAd";
import { Helmet } from "react-helmet-async";
import FeedbackModal from "./components/FeedbackButton/FeedbackModal";
import "./dashboard.css";
import { backend } from "../../backend";

function Dashboard() {
  const { page } = useParams();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [page]);

  const getDashboardTitle = () => {
    switch (page) {
      case "annonser":
        return "Mina sidor";
      case "skapa-annons":
        return "Skapa annons";
      case "redigera-annons":
        return "Redigera annons";
      case "support":
        return "Support";
      case "installningar":
        return "Mina inställningar";
      default:
        return "Dashboard";
    }
  };

  const renderBreadcrumbs = () => {
    switch (page) {
      case "skapa-annons":
        return (
          <>
            <Link to="/mina-sidor/annonser">Mina sidor</Link>&middot;
            <Link to="/mina-sidor/skapa-annons">Skapa annons</Link>
          </>
        );
      case "redigera-annons":
        return (
          <>
            <Link to="/mina-sidor/annonser">Mina sidor</Link>&middot;
            <Link to="/mina-sidor/annonser">Redigera annons</Link>
          </>
        );
      case "support":
        return (
          <>
            <Link to="/mina-sidor/annonser">Mina sidor</Link>&middot;
            <Link to="/mina-sidor/support">Support</Link>
          </>
        );
      case "installningar":
        return (
          <>
            <Link to="/mina-sidor/annonser">Mina sidor</Link>&middot;
            <Link to="/mina-sidor/installningar">Inställningar</Link>
          </>
        );
      default:
        return null;
    }
  };

  const loadContentHandlers = () => {
    switch (page) {
      case "annonser":
        return (
          <>
            <Helmet>
              <title>Mina annonser | Vakansa</title>
              <meta
                name="description"
                content="Hantera och uppdatera dina annonser enkelt på Vakansa. Få en översikt över dina aktiva och tidigare annonser."
              />
              <link rel="canonical" href={backend("/mina-sidor/annonser")} />
              <meta property="og:image" content="/images/logo/meta-logo.jpg" />
              <meta property="og:title" content="Mina sidor på Vakansa" />
              <meta
                property="og:description"
                content="Hantera och uppdatera dina annonser enkelt på Vakansa. Få en översikt över dina aktiva och tidigare annonser."
              />
              <meta name="robots" content="noindex" />
            </Helmet>
            <MyAds />
          </>
        );
      case "skapa-annons":
        return (
          <>
            <Helmet>
              <title>Skapa annons </title>
            </Helmet>
            <CreateAd />
          </>
        );
      case "redigera-annons":
        return (
          <>
            <Helmet>
              <title>Redigera annons </title>
            </Helmet>
            <EditAd />
          </>
        );
      case "support":
        return (
          <>
            <Helmet>
              <title>Support </title>
            </Helmet>
            <Support />
          </>
        );
      case "installningar":
        return (
          <>
            <Helmet>
              <title>Inställningar </title>
            </Helmet>
            <Settings />
          </>
        );
      default:
      // Redirect to 404 page
      // return <Navigate to="/sidan-kunde-hittas" />;
    }
  };

  return (
    <div className="dashboard-page">
      <div id="dashboard-breadcrumbs">
        <div className="render-breadcrumps">{renderBreadcrumbs(page)}</div>
        <FeedbackModal />
      </div>
      <div className="dashboard-header">
        <h1>{getDashboardTitle(page)}</h1>
      </div>
      <div className="dashboard-layout">
        <Sidebar />
        <div className="dashboard-content">{loadContentHandlers()}</div>
      </div>
    </div>
  );
}

export default Dashboard;
